import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.85 10.692a52 52 0 0 0-2.152 2.637A7.5 7.5 0 0 0 4 20.5c0 2.056-.568 3.508-1.112 4.432-.273.464-.543.8-.737 1.014a4 4 0 0 1-.275.273l-.007.006A1 1 0 0 0 2.5 28h9a7.5 7.5 0 0 0 7.17-9.698 52 52 0 0 0 2.698-2.206 40 40 0 0 0 3.391-3.326c2.282-2.55 4.366-5.711 4.366-8.895a1 1 0 0 0-1-1c-3.184 0-6.346 2.084-8.895 4.366a40 40 0 0 0-3.38 3.451m.976 1.934a51 51 0 0 0-1.268 1.567 7.5 7.5 0 0 1 2.25 2.249c.48-.374 1.01-.8 1.566-1.268a9.7 9.7 0 0 0-2.548-2.548m1.331-1.51a11.7 11.7 0 0 1 2.727 2.727 36 36 0 0 0 2.385-2.407c1.894-2.115 3.348-4.36 3.747-6.452-2.092.399-4.337 1.853-6.452 3.747a36 36 0 0 0-2.407 2.385m-4.423 4.358a1 1 0 0 1-.15-.064A5.498 5.498 0 0 0 6 20.5c0 2.445-.682 4.244-1.388 5.445L4.579 26H11.5a5.5 5.5 0 0 0 5.09-7.584 1 1 0 0 1-.064-.15 5.5 5.5 0 0 0-2.792-2.792"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPaintBrush = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPaintBrush);
export default Memo;
